import { render, staticRenderFns } from "./ProjectRecycle.vue?vue&type=template&id=52002456&"
import script from "./ProjectRecycle.vue?vue&type=script&lang=ts&"
export * from "./ProjectRecycle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports